import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from 'react-toastify';
import './core.scss'
import PageLayout from "./baseTemplate/PageLayout/PageLayout.tsx";
import Router from "./navigation.tsx";
import Loading from "./loading/Loading.tsx";


function App() {
    return (
        <div className="basic-body">
            <Loading></Loading>
            <BrowserRouter>
                <PageLayout>
                    <Router/>
                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                </PageLayout>
            </BrowserRouter>
        </div>
    );
}

export default App;
